import { useIsAuthenticated } from 'mf_core/auth';
import { useApiQuery } from 'mf_core/query';

export function useProductMenuQuery(locale: string, enabled: boolean) {
  const isAuthenticated = useIsAuthenticated();
  return useApiQuery<ProductNav[]>(
    `/shared/v1/product-categories`,
    { culture: locale },
    { enabled },
    undefined,
    { isLogoutApi: !isAuthenticated }
  );
}
export type ProductNav = {
  link: string | null;
  name: string;
  openInNewTab: boolean;
  sub: ProductNav[] | null;
};
